import { create } from "zustand";
import { DialogInfo, PageUnit } from "./data";

const defaultDialog : DialogInfo = {
    id: "",
    title: "Title",
    content: "",
    visible: true,
    confirmContent: "Confirm",
    confirmActive: true,
    onConfirm: undefined,
}

type ToastData = {
    Id      : number
    Title   : string
    Msg     : string
    Date    : Date
    Type?   : string
    Visible : boolean
}

type UXStoreProps = {
    pages       :Array<PageUnit>
    toasts      :ToastData[]
    currentPage :PageUnit | null
    homePage    : PageUnit | null
    setHome     : (home:PageUnit) => void
    pushPage: (label:string,element:any,id?:string) => void
    replacePage: (label:string, element:any, id?:string) => void
    pushHome: () => void
    popPage: () => void
    popUntil: (predicate:(page:PageUnit) => boolean) => void
    popAt: (index:number) => void

    // dialogs
    dialogs         : Map<string,DialogInfo>
    refreshDialog       : (dialog:DialogInfo,autohide?:boolean) => void
    removeDialog : (id:string) => void
    hideDialog : (id:string) => void

    // toasts
    addToast : (title:string,msg:string,date?:Date|null,type?:"warning"|"success"|"info"|"danger") => string
    removeToast : (id:number) => void
    hideToast: (id:number) => void
}

var toastRunning = 0

const useUXStore = create<UXStoreProps>( (set,getState) => ({
    pages:[],
    toasts:[],
    homePage: null,
    currentPage: null,
    pushPage(label, element, id) {
        const page = {Label:label,Element:element,Id:id};
        let pages = getState().pages
        pages = [...pages, page]
        set( state => ({pages:pages, currentPage:page}))
    },
    replacePage(label, element, id) {
        const page = {Label:label,Element:element,Id:id};
        set( state => ({pages:[page], currentPage:page}))
    },
    popPage() {
        let pages = getState().pages
        // skip popping
        if (pages.length < 2) return
        pages = [...pages]
        pages.pop()
        set( state => ({pages:pages, currentPage:pages[pages.length-1]}))
    },
    popUntil(predicate) {
        const originalPages = getState().pages
        let pages = [...originalPages]
        for (let index = 0; index < pages.length; index++) {
            const page = pages[index];
            if (!predicate(page!)) return

            pages.pop()
        }
        if (originalPages.length !== pages.length) {
            set( state => ({
                pages:pages, 
                currentPage: pages[pages.length-1]
            }))
        }
    },
    popAt(index) {
        const target= getState().pages[index]
        getState().popUntil( page => page.Label !== target.Element )
    },

    // dialogs
    dialogs : new Map<string, DialogInfo>(),
    refreshDialog: (dialog: DialogInfo, autohide=false) => {
        const dialogs = getState().dialogs
        const oldD = dialogs.get(dialog.id)
        const newD = oldD ? {...oldD, ...dialog} : {...defaultDialog, ...dialog} 
        if (autohide) {
            newD.onClose = () => getState().hideDialog(newD.id)
            if (dialog.onConfirm) {
                newD.onConfirm = () => {
                    if (dialog.onConfirm)
                        dialog!.onConfirm!()
                    getState().hideDialog(newD.id)
                    //console.log("hide")
                }
            }
        }
        dialogs.set(dialog.id, newD)
        //console.log("KKK", defaultDialog,oldD,newD)
        set( state => ({dialogs:dialogs}))
    },
    hideDialog(id) {
        getState().refreshDialog({id,visible:false})
    },
    removeDialog: (id:string) => {
        const newD = getState().dialogs
        newD.delete(id)
        set( state => ({dialogs: newD}))
    }, 
    addToast(title, msg, date, type) {
        const toasts = [...getState().toasts]
        if (type === null) type ="info"
        toastRunning ++
        if (date === null) date = new Date(Date.now())
        toasts.push({Id:toastRunning, Title:title,Msg:msg, Date:date!, Type:type, Visible: true})
        set( state => ({toasts:toasts}))
        return ""
    },
    removeToast(id) {
        setTimeout(() => {
            const toasts = [...getState().toasts]
            for (let index = 0; index < toasts.length; index++) {
                const element = toasts[index];
                if (element.Id === id) {
                    toasts.splice(index, 1)
                    set( state => ({toasts:toasts}))
                    //console.log(toasts)
                    break
                }
            }
        }, 1000)
    },
    hideToast(id) {
        const toasts = [...getState().toasts]
        for (let index = 0; index < toasts.length; index++) {
            const element = toasts[index];
            if (element.Id === id) {
                toasts[index].Visible = false
                set( state => ({toasts:toasts}))
                //console.log(toasts)
                getState().removeToast(id)
                break
            }
        }
    },
    pushHome() {
        const home = getState().homePage;
        getState().replacePage(home!.Label, home!.Element)
    },
    setHome(home) {
        set(state => ({homePage:home, currentPage: home}))
    },
}))

export default useUXStore